export default "__VITE_ASSET__b3OskO50__"